import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { Utils } from "@serasa/shared/utils/utils";
import { Observable } from "rxjs";
import { environment } from "../../../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class PrivacyService {
  constructor(private readonly _http: HttpClient) {}

  public loadTerms<T>(): Observable<T> {
    const headers = Utils.generateDefaultHeader();

    return this._http.get<T>(
      `${environment.logonPortalBaseUrl}/my-terms?latest-version=true`,
      {
        headers,
      },
    );
  }

  public sendAgreement<T>(version: string): Observable<T> {
    const headers = Utils.generateDefaultHeader();

    return this._http.post<T>(
      `${environment.logonPortalBaseUrl}/my-terms/accept?version=${version}`,
      {},
      {
        headers,
      },
    );
  }
}
